<template>
  <b-container>
    <h1>{{ $t("gasStation.edit") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <GasStationCrud
          ref="crudData"
          :model="model"
          :modelstate="modelstate"
        />
      </b-col>
    </b-row>
    <!-- {{ model }} -->
    <b-button @click="save()" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
  <script>
export default {
  name: "GasStationEdit",
  props: {
    id: String,
  },
  components: {
    GasStationCrud: () =>
      import("@/components_rms/fuelSupplies/gasStation/GasStationCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  created() {
    this.loadData();
  },
  computed: {
    getUrlBackToList() {
      return `../list`;
    },
  },
  data() {
    return {
      alert: {
        error: "",
        success: this.$t("gasStation.editSuccess"),
      },
      submitted: false,
      model: {},
      modelstate: {},
    };
  },

  methods: {
    loadData() {
      this.$apiVehicle
        .get("/gasStation/getById/" + this.id)
        .then((response) => {
          this.model = response.data;
          this.modelstate = {};
          //   this.$refs.crudData.refreshData();
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    save() {
      this.submitted = true;
      console.log(this.model);
      this.$apiVehicle
        .post("/gasStation/edit/", this.model)
        .then((response) => {
          this.submitted = false;
          this.modelstate = {};
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
  },
};
</script>
  